<template>
  <va-modal
    id="rateCallModal"
    ref="rateCallModal"
    :value="isOpen"
    :okText="$t('modals.buttons.submit')"
    @ok="submit"
    size="small"
    :noOutsideDismiss="true"
    :hideDefaultActions="true">

    <div slot="header" class="modal-title">
      <span>{{ $t('evocall.requests.rate_header') }}</span>
    </div>

    <form class="evollu-form">

      <div class="row">

        <div class="col-12">
          <span>
            <i class="fa fa-clock-o is-bold" style="margin-right: 2px; margin-bottom: 0.7rem;"></i>
            <span class="is-bold"> {{ request.started_at | localTime('DD MMMM YYYY HH:mm') }} - {{ request.ended_at | localTime('HH:mm') }}</span>
          </span>
        </div>

        <div class="col-12" v-if="!isRatingCreator">
          <label>{{ $t('evocall.requests.facility') }}:&nbsp;</label>
          <span class="is-bold">{{ request.facility_name ? request.facility_name : '' }}</span>
        </div>

        <div class="col-12" v-if="isRatingCreator">
          <label>{{ this.$t('evocall.requests.creator') }}:&nbsp;</label>
          <span class="is-bold">{{ request.dispenser_nickname ? request.dispenser_nickname : '' }}</span>
        </div>

        <div class="col-12" v-else>
          <label>{{ this.$t('evocall.requests.accepted') }}:&nbsp;</label>
          <span class="is-bold">{{ request.accepted_by_nickname ? request.accepted_by_nickname : '' }}</span>
        </div>

        <div class="col-12">
          <label>{{ this.$t('virtual_waiting_room.titles.customer_nr') }}:&nbsp;</label>
          <span class="is-bold">{{ request.customer_number ? request.customer_number : '' }}</span>
        </div>
      </div>

      <div class="row">
        <div class="col-12">
          <span v-if="isRatingCreator">{{ $t('evocall.requests.rate_dispenser_header') }}</span>
          <span v-else>{{ $t('evocall.requests.rate_audiologist_header') }}</span>
        </div>
      </div>

      <div class="row justify-content-center">
        <va-rating
          v-model="rate"
          size="large"
          color="info" />
      </div>

      <div class="row">
        <div class="col-12">
          <va-input
            v-model="comment"
            :label="$t('evocall.requests.comment')"
            type="textarea"
            :minRows="3"
            :maxRows="8" />
        </div>
      </div>
    </form>

    <div slot="actions" class="d-flex justify-content-end w-100">
      <va-button
        @click="submit"
        :disabled="isSubmitting">
          {{ $t('modals.buttons.submit') }}
      </va-button>
    </div>

  </va-modal>
</template>
<script>
import { RequestService } from '@/api/VirtualWaitingRoomService'
import EventBus from '@/utils/EventBus'
export default {
  props: {
    request: {
      type: Object,
      required: true
    },
    memberType: {
      type: String,
      required: true,
      validator: (value) => {
        return ['audiologist', 'dispenser'].includes(value)
      }
    },
  },
  data () {
    return {
      isOpen: false,
      rate: null,
      comment: null,
      isSubmitting: false
    }
  },
  mounted () {
    this.isOpen = true
    EventBus.$on('CLOSE_RATE_MODAL_AUDIOLOGIST', (request) => {
      if (this.$auth.user().id === request.acceptee.id) {
        this.isOpen = false
      }
    })
  },
  methods: {
    getFormData: function () {
      let data = {}
      if (this.memberType === 'audiologist') {
        data.dispenser_rating = this.rate
        data.dispenser_comment = this.comment
      } else {
        data.audiologist_rating = this.rate
        data.audiologist_comment = this.comment
      }
      return data
    },
    submit: function () {
      if (!this.canSubmit) {
        this.showToast(this.$t('evocall.requests.required_rate'), this.$store.state.errorToastOptions)
        return
      }
      this.isSubmitting = true
      RequestService.rateRequest(this.request.id, this.getFormData())
        .then(() => {
          this.isOpen = false
          this.$nextTick(() => {
            this.showToast(this.$t('evocall.requests.rate_submitted'), this.$store.state.successToastOptions)
            this.$emit('rate-submitted')
          })
        }).catch(errors => {
          console.log('errors', errors)
        }).finally(() => {
          this.isSubmitting = false
        })
    }
  },
  computed: {
    isRatingCreator: function () {
      return this.memberType === 'audiologist'
    },
    canSubmit: function () {
      return this.rate !== null
    }
  }
}
</script>
